export const STAGE_TYPE_INCOMING = 'INCOMING' as const;
export const STAGE_TYPE_OUTGOING = 'OUTGOING' as const;
export const STAGE_TYPE_BACKLOG = 'BACKLOG' as const;
export const STAGE_TYPE_ATTESTATION = 'ATTESTATION' as const;
